<template>
  <section>
    <div class="infoModifyDiv">
      <div class="warnTitle" v-if="Number(isComplete) === 0">
        首次登录请先完善单位信息！
      </div>
      <div class="warn" v-if="type === 'edit' || Number(isComplete) === 0">
        请务必如实填写，如提供虚假信息我司<br />
        或将采取一定的惩罚措施！
      </div>
      <div class="cont2">
        <div class="cont2-label">
          单位全称<span style="color: red;">*</span>
        </div>
        <van-field
          v-model="params.fullName"
          placeholder="请输入营业执照上的单位全称"
        />
      </div>
      <div class="cont2">
        <van-cell-group class="requried">
          <van-field
            v-model="params.shortName"
            label="单位简称"
            maxlength="10"
            placeholder="请输入10个字符以内的简称"
            style="font-size: 17px;"
          />
        </van-cell-group>
      </div>
      <div class="cont2">
        <div class="cont2-label">
          统一社会信用代码<span style="color: red;">*</span>
        </div>
        <van-field
          v-model="params.creditCode"
          placeholder="请输入营业执照上的统一社会信用代码"
        />
      </div>
      <div class="cont2">
        <div class="cont2-label">
          营业执照扫描件<span style="color: red;">*</span>
        </div>
        <van-uploader
          v-model="params.file"
          :multiple="false"
          :max-count="1"
          :after-read="onFileRead"
          :before-delete="onDeleteFile"
          style="margin: 15px 16px 21px;"
          accept="image/jpg, image/jpeg, image/png"
        >
          <template #default>
            <div class="card-img-div">
              <div class="card-img-div-icon">
                <van-icon name="plus" size="17" /><br />
                上传
              </div>
            </div>
          </template>
        </van-uploader>
      </div>
      <div class="cont1">
        <van-cell-group class="requried" style="width: calc(100vh - 34px);">
          <van-field
            v-model="params.scale"
            label="企业规模"
            placeholder="请选择规模"
            right-icon="arrow-down"
            readonly
            @click="selectScale"
            style="padding: 13px 0px;"
          />
        </van-cell-group>
      </div>
      <div class="cont2">
        <div class="cont2-label">
          经营范围<span style="color: red;">*</span>
        </div>
        <van-field
          type="textarea"
          rows="1"
          autosize
          v-model="params.scope"
          placeholder="请输入概要的经营范围，支持100个字符以内"
          maxlength="100"
        />
      </div>
      <div class="cont2">
        <van-cell-group class="requried">
          <van-field
            v-model="params.name"
            label="主要联系人"
            placeholder="请输入姓名"
            style="font-size: 17px;"
          />
          <van-field
            v-model="params.phone"
            label="手机号码"
            placeholder="请输入手机号码"
            style="font-size: 17px;"
          />
          <van-field
            v-model="params.cardNum"
            label="身份证号码"
            placeholder="请输入身份证号码"
            style="font-size: 17px;"
          />
        </van-cell-group>
      </div>
      <div style="height: 130px;background-color: #f4f5f6;"></div>
      <div class="footer-cont2">
        <van-button type="primary" block class="btnStyle1" @click="saveCheck"
          >保存</van-button
        >
        <van-button
          type="primary"
          block
          class="btnStyle2"
          v-if="type === 'edit'"
          @click="
            $router.push({
              path: 'rhwxInfoDetail'
            })
          "
          >取消</van-button
        >
      </div>

      <!-- 弹窗 -->
      <van-dialog
        v-model="dialogShow"
        show-cancel-button
        title="注意"
        :showConfirmButton="false"
        :showCancelButton="false"
      >
        <template #default>
          <div class="dialog-blk">
            <div>
              确定要保存单位信息吗？<br />
              <span class="colorPink">请核实并确保所有信息无误！</span>
            </div>
          </div>
          <div style="display: flex;">
            <div style="flex: 1;" @click="dialogShow = false">
              <van-button block class="dialogBtnCancel">
                取消
              </van-button>
            </div>
            <div style="flex: 1;" @click="save">
              <van-button block class="dialogBtnConfirm">确认保存</van-button>
            </div>
          </div>
        </template>
      </van-dialog>

      <van-popup v-model="pickerShow" position="bottom">
        <van-picker
          show-toolbar
          :columns="columnScale"
          @confirm="onConfirmScale"
          @cancel="pickerShow = false"
        />
      </van-popup>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      params: {
        id: "",
        fullName: "", // 全称
        shortName: "", // 简称
        creditCode: "", // 统一社会信用代码
        fileObj: {}, // 文件
        fileUrl: "",
        file: [],
        scale: "", // 经营规模
        scope: "", // 经营范围
        name: "", // 主要联系人
        cardNum: "", // 身份证号
        phone: "" // 手机号
      },
      dialogShow: false,
      pickerShow: false,
      columnScale: [
        "1-30人",
        "31-50人",
        "51-100人",
        "101-200人",
        "201-500人",
        "501-1000人",
        "1001及以上"
      ],
      rowDataObj: {}
    };
  },
  created() {},
  methods: {
    onFileRead(file) {
      let data = new FormData();
      data.append("file", file.file);
      if (!/(\.jpeg)|(\.jpg)|(\.png)/.test(file.file.name.toLowerCase())) {
        this.$common.mbToastFail("只能上传jpeg、jpg、png文件");
        this.params.file = [];
        return false;
      }
      if (file.file.size > 1024 * 1000 * 20) {
        this.$common.mbToastFail("文件大小不能超过20M");
        this.params.file = [];
        return false;
      }
      this.$common
        .http({
          url: "/api/media/upload",
          file: data
        })
        .then(res => {
          if (res.data.data.real_path) {
            this.params.fileObj = res.data.data;
            this.$common.mbToastSuccess("上传成功");
          } else {
            this.params.file = [];
          }
        });
    },

    onDeleteFile() {
      this.params.fileObj = {};
      return true;
    },

    // 获取单位详情
    async getDetail() {
      await this.$common
        .http({
          url: "/api/supplier/unit_detail"
        })
        .then(res => {
          console.log(res);
          this.rowDataObj = res.data.data;
          this.params.id = this.rowDataObj.id;
          this.params.fullName = this.rowDataObj.full_name;
          this.params.shortName = this.rowDataObj.short_name;
          this.params.creditCode = this.rowDataObj.unified_social_credit_code;
          this.params.scale =
            this.rowDataObj.unit_size === 0
              ? ""
              : this.columnScale[this.rowDataObj.unit_size - 1];
          this.params.scope = this.rowDataObj.business_scope;
          this.params.name = this.rowDataObj.contact;
          this.params.cardNum = this.rowDataObj.id_card;
          this.params.phone = this.rowDataObj.phone;

          if (this.rowDataObj.files.length > 0) {
            this.params.file = [
              {
                url: this.rowDataObj.files[0].real_path,
                urlObj: this.rowDataObj.files[0]
              }
            ];
            this.params.fileObj = this.rowDataObj.files[0];
          }
        });
    },

    saveCheck() {
      if (this.params.fullName.trim() === "") {
        this.$common.mbToastFail("单位全称不能为空");
        return false;
      }
      if (this.params.shortName.trim() === "") {
        this.$common.mbToastFail("单位简称不能为空");
        return false;
      }
      if (this.params.creditCode.trim() === "") {
        this.$common.mbToastFail("统一社会信用代码不能为空");
        return false;
      }
      if (this.params.file.length === 0) {
        this.$common.mbToastFail("请上传营业执照扫描件");
        return false;
      }
      if (this.params.scale.trim() === "") {
        this.$common.mbToastFail("请选择企业规模");
        return false;
      }
      if (this.params.scope.trim() === "") {
        this.$common.mbToastFail("经营范围不能为空");
        return false;
      }
      if (this.params.name.trim() === "") {
        this.$common.mbToastFail("主要联系人不能为空");
        return false;
      }
      if (this.params.phone.trim() === "") {
        this.$common.mbToastFail("手机号码不能为空");
        return false;
      }
      if (
        !/^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/.test(
          this.params.phone.trim()
        )
      ) {
        this.$common.mbToastFail("手机号码的格式不正确");
        return false;
      }
      if (this.params.cardNum.trim() === "") {
        this.$common.mbToastFail("身份证号码不能为空");
        return false;
      }
      if (
        !/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          this.params.cardNum.trim()
        )
      ) {
        this.$common.mbToastFail("身份证号码的格式不正确");
        return false;
      }
      this.dialogShow = true;
    },

    save() {
      this.dialogShow = false;
      let arr = [];
      arr.push(this.params.fileObj);
      let data = {
        id: this.params.id,
        full_name: this.params.fullName,
        short_name: this.params.shortName,
        unified_social_credit_code: this.params.creditCode,
        unit_size: this.columnScale.indexOf(this.params.scale) + 1,
        business_scope: this.params.scope,
        contact: this.params.name,
        phone: this.params.phone,
        id_card: this.params.cardNum,
        files: JSON.stringify(arr)
      };
      console.log(data);
      this.$common
        .http({
          url: "/api/supplier/update_unit_detail",
          data: data
        })
        .then(() => {
          this.$common.mbToastSuccess("保存成功");
          setTimeout(() => {
            if (this.type === "edit") {
              this.$router.push({ path: "/rhwxInfoDetail" });
            } else {
              this.$router.push({ path: "/rhwxWelcome" });
            }
          }, 1500);
        });
    },

    // 企业规模
    selectScale() {
      console.log("kkk");
      this.pickerShow = true;
    },

    // 选择规模
    onConfirmScale(value, index) {
      console.log(value, index);
      this.params.scale = value;
      this.pickerShow = false;
    }
  },
  mounted() {
    if (this.type === "edit") {
      document.title = "修改单位信息";
    } else {
      document.title = "完善单位信息";
    }
    this.getDetail();
  },
  computed: {
    type() {
      return this.$route.query.type || 0;
    },
    isComplete() {
      return this.$route.query.is_complete;
    }
  }
};
</script>
<style lang="less">
@import "../assets/css/common";
.infoModifyDiv {
  min-height: calc(100vh - 1px);
  background: #f4f5f6;
  box-sizing: border-box;
  border-top: 1px solid #f4f5f6;
  font-size: 16px;
  .warnTitle {
    color: #ec3f67;
    line-height: 23px;
    padding: 10px 17px 0px;
    background: #e7fbf7;
  }
  .warn {
    background: #e7fbf7;
    color: #009967;
    padding: 10px 17px;
    line-height: 23px;
  }
  .cont1 {
    line-height: 54px;
    background: #fff;
    font-size: 14px;
    display: flex;
    padding: 0px 15px;
    margin-bottom: 10px;
    .left {
      flex: 1;
    }
    .right {
      flex: 0.5;
      text-align: right;
    }
  }
  .cont2 {
    background: #fff;
    margin: 0px 0px 10px;
    &-label {
      padding: 19px 16px 0px;
    }
  }
  .card-img-div {
    color: #999999;
    font-size: 11px;
    display: inline-block;
    border: 1px solid #d9d9d9;
    object-fit: cover;
    width: 60px;
    height: 60px;
    vertical-align: text-bottom;
    &-icon {
      text-align: center;
      top: 50%;
      position: relative;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
.van-cell {
  background-color: inherit;
  border-radius: 5px;
  line-height: 31px;
  padding: 14px 16px;
  font-size: 16px;
}
.van-cell::after {
  border-bottom: 1px solid #dcdcdd;
}
.van-field__label {
  color: #333;
}
</style>
<style lang="less">
.van-uploader__preview {
  margin: 0px;
}
.van-uploader__preview-image {
  width: inherit;
  height: inherit;
  object-fit: cover;
  vertical-align: top;
  width: 60px;
  height: 60px;
}
</style>
